import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes, FaSearch, FaFilter, FaChevronDown, FaChevronUp, FaCheck } from "react-icons/fa";
import { UrlContext } from "../../contexts/UrlContext";
import { ensureConnectionAndExecute } from "../../utils/eph-connection-manager";
import { pollTaskStatus } from "../../utils/taskStatus";


const TOP_CONSULTING_COMPANIES = [
  "EY", "Accenture", "PwC", "Deloitte", "McKinsey & Company", "KPMG", 
  "Boston Consulting Group (BCG)", "Capgemini", "Roland Berger", "BearingPoint", 
  "Kearney", "Detecon", "Oliver Wyman", "Bain & Company", "P3", "Porsche Consulting", 
  "Strategy&", "Arthur D. Little", "OC&C Strategy Consultants", "Monitor Deloitte", 
  "Mercer", "EY-Parthenon", "PA Consulting", "Inverto | A BCG Company", "L.E.K. Consulting"
];

const AdvancedFiltersPopup = ({
  isOpen,
  onClose,
  onApplyFilters,
  onFiltersSaved,
  projectId,
  project,
  initialFilters = {},
  allProjectFilters = []
}) => {
  const { URI } = useContext(UrlContext);
  const [filters, setFilters] = useState({
    // Location filters
    locations: [
      "Remote",
      "Afghanistan",
      "Åland Islands",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Indian Ocean Territory",
      "Brunei Darussalam",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cape Verde",
      "Cayman Islands",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Cocos (Keeling) Islands",
      "Colombia",
      "Comoros",
      "Congo",
      "Congo, The Democratic Republic of The",
      "Cook Islands",
      "Costa Rica",
      "Cote D'ivoire",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands (Malvinas)",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern Territories",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-bissau",
      "Guyana",
      "Haiti",
      "Heard Island and Mcdonald Islands",
      "Holy See (Vatican City State)",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran, Islamic Republic of",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea, Democratic People's Republic of",
      "Korea, Republic of",
      "Kuwait",
      "Kyrgyzstan",
      "Lao People's Democratic Republic",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libyan Arab Jamahiriya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macao",
      "Macedonia, The Former Yugoslav Republic of",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mexico",
      "Micronesia, Federated States of",
      "Moldova, Republic of",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "Northern Mariana Islands",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestinian Territory, Occupied",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Pitcairn",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "Rwanda",
      "Saint Helena",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Pierre and Miquelon",
      "Saint Vincent and The Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and The South Sandwich Islands",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Svalbard and Jan Mayen",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syrian Arab Republic",
      "Taiwan, Province of China",
      "Tajikistan",
      "Tanzania, United Republic of",
      "Thailand",
      "Timor-leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "United States Minor Outlying Islands",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Viet Nam",
      "Virgin Islands, British",
      "Virgin Islands, U.S.",
      "Wallis and Futuna",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
      "Europe",
      "Middle East",
      "Asia Pacific",
      "Africa",
      "North America",
      "Latin America",
      "Global"
    ],
    selectedLocations: [],

    // Industry filters
    industries: [
      "Technology",
      "Software Development",
      "Information Technology",
      "Artificial Intelligence",
      "Machine Learning",
      "Data Science",
      "Cybersecurity",
      "Cloud Computing",
      "Financial Services",
      "Banking",
      "Investment Banking",
      "Insurance",
      "FinTech",
      "Cryptocurrency",
      "Healthcare",
      "Pharmaceuticals",
      "Biotechnology",
      "Medical Devices",
      "Telemedicine",
      "Consulting",
      "Management Consulting",
      "Strategy Consulting",
      "IT Consulting",
      "Business Consulting",
      "Marketing & Advertising",
      "Digital Marketing",
      "Content Marketing",
      "Social Media",
      "Public Relations",
      "E-commerce",
      "Retail",
      "Consumer Goods",
      "Fashion",
      "Automotive",
      "Manufacturing",
      "Aerospace",
      "Defense",
      "Energy",
      "Oil & Gas",
      "Renewable Energy",
      "Utilities",
      "Real Estate",
      "Construction",
      "Architecture",
      "Education",
      "Higher Education",
      "EdTech",
      "Media & Entertainment",
      "Gaming",
      "Sports",
      "Travel & Tourism",
      "Hospitality",
      "Food & Beverage",
      "Agriculture",
      "Legal Services",
      "Government",
      "Non-Profit",
      "Transportation",
      "Logistics",
      "Supply Chain",
      "Telecommunications",
      "Internet",
      "Mobile",
      "SaaS",
      "Human Resources",
      "Recruiting",
      "Sales",
      "Customer Service",
      "Operations",
      "Project Management",
      "Quality Assurance",
      "Research & Development",
      "Design",
      "UX/UI Design",
      "Graphic Design",
      "Product Management",
      "Business Development",
      "Venture Capital",
      "Private Equity",
      "Investment Management",
      "Accounting",
      "Audit",
      "Tax Services",
      "Compliance",
      "Risk Management"
    ],
    selectedIndustries: [],

    // Job Title filters
    jobTitles: [
      "Software Engineer",
      "Senior Software Engineer",
      "Full Stack Developer",
      "Frontend Developer",
      "Backend Developer",
      "Data Scientist",
      "Data Analyst",
      "Data Engineer",
      "Machine Learning Engineer",
      "AI Engineer",
      "DevOps Engineer",
      "Cloud Engineer",
      "Cybersecurity Specialist",
      "Information Security Analyst",
      "Product Manager",
      "Technical Product Manager",
      "Project Manager",
      "Scrum Master",
      "UX Designer",
      "UI Designer",
      "UX/UI Designer",
      "Graphic Designer",
      "Web Designer",
      "Business Analyst",
      "Systems Analyst",
      "Database Administrator",
      "Network Administrator",
      "IT Support Specialist",
      "Technical Writer",
      "Quality Assurance Engineer",
      "Test Engineer",
      "Automation Engineer",
      "Site Reliability Engineer",
      "Solutions Architect",
      "Software Architect",
      "Technical Lead",
      "Engineering Manager",
      "CTO",
      "VP of Engineering",
      "Marketing Manager",
      "Digital Marketing Specialist",
      "Content Manager",
      "SEO Specialist",
      "Social Media Manager",
      "Sales Manager",
      "Account Manager",
      "Customer Success Manager",
      "Business Development Manager",
      "Financial Analyst",
      "Accountant",
      "Operations Manager",
      "HR Manager",
      "Recruiter",
      "Consultant",
      "Strategy Consultant",
      "Management Consultant",
      "Legal Counsel",
      "Lawyer",
      "Research Scientist",
      "Biomedical Engineer",
      "Mechanical Engineer",
      "Electrical Engineer",
      "Civil Engineer",
      "Chemical Engineer",
      "Aerospace Engineer",
      "Manufacturing Engineer",
      "Supply Chain Manager",
      "Logistics Coordinator",
      "Real Estate Agent",
      "Investment Analyst",
      "Portfolio Manager",
      "Risk Analyst",
      "Compliance Officer",
      "Audit Manager",
      "Tax Advisor",
      "Healthcare Administrator",
      "Nurse",
      "Doctor",
      "Physician",
      "Pharmacist",
      "Physical Therapist",
      "Teacher",
      "Professor",
      "Instructional Designer",
      "Training Specialist"
    ],
    selectedJobTitles: [],

    // Experience filters
    experienceLevels: [
      { id: 'less-than-1', label: 'Less than 1 year', count: 0 },
      { id: '1-to-2', label: '1 to 2 years', count: 0 },
      { id: '3-to-5', label: '3 to 5 years', count: 0 },
      { id: '6-to-10', label: '6 to 10 years', count: 0 },
      { id: 'more-than-10', label: 'More than 10 years', count: 0 }
    ],
    selectedExperienceLevels: [],



    // Skills filters
    skills: [
      // Programming Languages
      "JavaScript",
      "TypeScript",
      "Python",
      "Java",
      "C#",
      "C++",
      "Go",
      "Rust",
      "PHP",
      "Ruby",
      "Swift",
      "Kotlin",
      "Scala",
      "R",
      "MATLAB",
      "SQL",
      "HTML",
      "CSS",

      // Frontend Technologies
      "React",
      "Angular",
      "Vue.js",
      "Next.js",
      "Svelte",
      "jQuery",
      "Bootstrap",
      "Tailwind CSS",
      "SASS/SCSS",
      "Material-UI",
      "Styled Components",
      "Webpack",
      "Vite",

      // Backend Technologies
      "Node.js",
      "Express.js",
      "Django",
      "Flask",
      "FastAPI",
      "Spring Boot",
      "ASP.NET",
      "Ruby on Rails",
      "Laravel",
      "Symfony",

      // Databases
      "MySQL",
      "PostgreSQL",
      "MongoDB",
      "Redis",
      "Oracle",
      "SQL Server",
      "SQLite",
      "Cassandra",
      "DynamoDB",
      "Firebase",
      "Supabase",

      // Cloud & DevOps
      "AWS",
      "Azure",
      "Google Cloud",
      "Docker",
      "Kubernetes",
      "Jenkins",
      "GitLab CI",
      "GitHub Actions",
      "Terraform",
      "Ansible",
      "Nginx",
      "Apache",

      // Data Science & AI
      "Machine Learning",
      "Deep Learning",
      "TensorFlow",
      "PyTorch",
      "Scikit-learn",
      "Pandas",
      "NumPy",
      "Jupyter",
      "Power BI",
      "Tableau",
      "Apache Spark",
      "Hadoop",

      // Mobile Development
      "React Native",
      "Flutter",
      "iOS Development",
      "Android Development",
      "Xamarin",
      "Ionic",

      // Design & UX
      "Figma",
      "Adobe XD",
      "Sketch",
      "Adobe Photoshop",
      "Adobe Illustrator",
      "InVision",
      "Principle",
      "Framer",
      "User Research",
      "Wireframing",
      "Prototyping",

      // Project Management
      "Agile",
      "Scrum",
      "Kanban",
      "Jira",
      "Confluence",
      "Trello",
      "Asana",
      "Monday.com",
      "Slack",
      "Microsoft Teams",

      // Marketing & Analytics
      "Google Analytics",
      "Google Ads",
      "Facebook Ads",
      "SEO",
      "SEM",
      "Content Marketing",
      "Email Marketing",
      "Social Media Marketing",
      "HubSpot",
      "Salesforce",

      // Other Technical Skills
      "Git",
      "REST APIs",
      "GraphQL",
      "Microservices",
      "Blockchain",
      "Cybersecurity",
      "Penetration Testing",
      "Network Security",
      "GDPR Compliance",
      "API Development",
      "Testing",
      "Unit Testing",
      "Integration Testing",
      "Automation Testing"
    ],
    selectedSkills: [],

    // Company filters
    companies: [
      "Google",
      "Microsoft",
      "Amazon",
      "Apple",
      "Meta",
      "Netflix",
      "Tesla",
      "NVIDIA",
      "Intel",
      "IBM",
      "Oracle",
      "Salesforce",
      "Adobe",
      "Uber",
      "Airbnb",
      "Spotify",
      "Twitter",
      "LinkedIn",
      "Snapchat",
      "TikTok",
      "Zoom",
      "Slack",
      "Dropbox",
      "GitHub",
      "Atlassian",
      "Shopify",
      "Square",
      "PayPal",
      "Stripe",
      "Coinbase",
      "Robinhood",
      "DoorDash",
      "Instacart",
      "Lyft",
      "Peloton",
      "Palantir",
      "Snowflake",
      "Databricks",
      "MongoDB",
      "Elastic",
      "Twilio",
      "Okta",
      "CrowdStrike",
      "ServiceNow",
      "Workday",
      "Zscaler",
      "Cloudflare",
      "Fastly",
      "Redis",
      "Docker",
      "GitLab",
      "JetBrains",
      "Unity",
      "Epic Games",
      "Roblox",
      "Discord",
      "Reddit",
      "Pinterest",
      "Etsy",
      "eBay",
      "Shopee",
      "Alibaba",
      "Tencent",
      "Baidu",
      "ByteDance",
      "Xiaomi",
      "Samsung",
      "Sony",
      "Panasonic",
      "LG",
      "Huawei",
      "Lenovo",
      "Dell",
      "HP",
      "Cisco",
      "VMware",
      "Red Hat",
      "Canonical",
      "SUSE",
      "Citrix",
      "Splunk",
      "New Relic",
      "DataDog",
      "PagerDuty",
      "HashiCorp",
      "Terraform",
      "Ansible",
      "Chef",
      "Puppet",
      "Jenkins",
      "CircleCI",
      "Travis CI",
      "Bitbucket",
      "SourceForge",
      "Stack Overflow",
      "Coursera",
      "Udemy",
      "Khan Academy",
      "Duolingo",
      "Grammarly",
      "Notion",
      "Airtable",
      "Asana",
      "Trello",
      "Monday.com",
      "Basecamp",
      "Figma",
      "Sketch",
      "Adobe Creative Cloud",
      "Canva",
      "InVision"
    ],
    selectedCompanies: [],

    // Keywords filters
    selectedKeywords: [],

    // Language filters
    languages: [
      { id: 'english', label: 'English', count: 0 },
      { id: 'spanish', label: 'Spanish', count: 0 },
      { id: 'french', label: 'French', count: 0 },
      { id: 'german', label: 'German', count: 0 },
      { id: 'chinese', label: 'Chinese', count: 0 }
    ],
    selectedLanguages: []
  });

  const [expandedSections, setExpandedSections] = useState({
    location: false,
    industry: false,
    jobTitle: false,
    experience: false,
    skills: false,
    company: false,
    keywords: false,
    languages: false
  });

  const [searchTerms, setSearchTerms] = useState({
    location: '',
    industry: '',
    jobTitle: '',
    skills: '',
    company: ''
  });

  // Store search terms used for filtering (updated after debounce)
  const [filterSearchTerms, setFilterSearchTerms] = useState({
    location: '',
    industry: '',
    jobTitle: '',
    skills: '',
    company: ''
  });

  const [loading, setLoading] = useState(false);
  const [resultCount, setResultCount] = useState(0);

  // State for keyword input value and edit mode
  const [keywordInputValue, setKeywordInputValue] = useState('');
  const [isKeywordEditMode, setIsKeywordEditMode] = useState(false);
  const [editingKeyword, setEditingKeyword] = useState(null);
  const [activeKeywordMenu, setActiveKeywordMenu] = useState(null);
  const [activePillMenu, setActivePillMenu] = useState(null); // For other sections
  const [keywordMenuPosition, setKeywordMenuPosition] = useState({});
  const [pillMenuPosition, setPillMenuPosition] = useState({});
  const [isSuggestingKeywords, setIsSuggestingKeywords] = useState(false);
  const [aiSuggestedKeywords, setAiSuggestedKeywords] = useState([]);
  
  // Centralized state for all pill options (priority and preference)
  const [pillOptions, setPillOptions] = useState({});

  // State for user filter selection
  const [selectedUser, setSelectedUser] = useState('current'); // 'current' means current user's filters
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  // Set right before filters are loaded (not edited), so the autosave skips that change
  const filtersLoadedRef = React.useRef(false);

  // Check if initialFilters matches any user's filters by ID and set selected user accordingly
  React.useEffect(() => {
    console.log("Checking for matching filter ID...");
    console.log("initialFilters:", initialFilters);
    console.log("allProjectFilters:", allProjectFilters);
    
    if (initialFilters && (initialFilters.id || initialFilters.ID) && allProjectFilters && allProjectFilters.length > 0) {
      const filterIdToMatch = initialFilters.id || initialFilters.ID;
      console.log("Looking for filter ID:", filterIdToMatch);
      
      const matchingFilter = allProjectFilters.find(filter => 
        filter.id === filterIdToMatch || 
        filter.ID === filterIdToMatch ||
        String(filter.id) === String(filterIdToMatch) ||
        String(filter.ID) === String(filterIdToMatch)
      );
      
      console.log("Matching filter found:", matchingFilter);
      
      if (matchingFilter && matchingFilter.created_by) {
        console.log("Setting selected user to:", matchingFilter.created_by);
        setSelectedUser(matchingFilter.created_by);
      } else {
        console.log("No matching filter found, setting to 'current'");
        setSelectedUser('current');
      }
    } else {
      console.log("No ID in initialFilters or no allProjectFilters, setting to 'current'");
      setSelectedUser('current');
    }
  }, [initialFilters, allProjectFilters]);

  // Get unique users from allProjectFilters
  const getUniqueUsers = () => {
    console.log("allProjectFilters", allProjectFilters);
    if (!allProjectFilters || allProjectFilters.length === 0) return [];
    
    const uniqueUsers = [];
    const seenUsers = new Set();
    
    allProjectFilters.forEach(filter => {
      if (filter.created_by && !seenUsers.has(filter.created_by)) {
        seenUsers.add(filter.created_by);
        uniqueUsers.push({
          value: filter.created_by,
          label: filter.created_by,
          id: filter.created_by
        });
      }
    });
    
    return uniqueUsers;
  };

  // Get display name for selected user
  const getSelectedUserDisplayName = () => {
    if (selectedUser === 'current') {
      return 'My Filters';
    }
    
    // Check if the selected user exists in the unique users list
    const uniqueUsers = getUniqueUsers();
    const userExists = uniqueUsers.some(user => user.value === selectedUser);
    
    if (userExists) {
      return selectedUser;
    }
    
    // If user doesn't exist in the list anymore, fall back to 'My Filters'
    return 'My Filters';
  };

  // Handle user selection change
  const handleUserSelectionChange = (userId) => {
    setSelectedUser(userId);
    setUserDropdownOpen(false);
    
    if (userId === 'current') {
      // Reset to current user's filters (initialFilters)
      // Map experience level labels back to IDs
      const selectedExperienceLevels = (initialFilters.yearsOfExperience || []).map(item => {
        const labelValue = typeof item === 'string' ? item : (item.value || item.label || String(item));
        const level = filters.experienceLevels.find(level => level.label === labelValue);
        return level?.id || labelValue;
      }).filter(Boolean);

      // Map language labels back to IDs
      const selectedLanguages = (initialFilters.languages || []).map(item => {
        const labelValue = typeof item === 'string' ? item : (item.value || item.label || String(item));
        const language = filters.languages.find(lang => lang.label === labelValue);
        return language?.id || labelValue;
      }).filter(Boolean);

      // Transform keywords from {value, priority, preference} to {id, text, priority, preference}
      const selectedKeywords = (initialFilters.keywords || []).map(keyword => {
        if (typeof keyword === 'string') {
          return {
            id: Date.now().toString() + Math.random(),
            text: keyword,
            priority: 'Can have',
            preference: 'Current or Past'
          };
        } else if (keyword && typeof keyword === 'object') {
          const text = keyword.value || keyword.text || keyword.label || String(keyword);
          return {
            id: keyword.id || (Date.now().toString() + Math.random()),
            text: typeof text === 'string' ? text : String(text),
            priority: keyword.priority || 'Can have',
            preference: keyword.preference || 'Current or Past'
          };
        }
        return {
          id: Date.now().toString() + Math.random(),
          text: String(keyword),
          priority: 'Can have',
          preference: 'Current or Past'
        };
      }).filter(item => item.text && item.text.trim());

      // Helper function to extract values from filter items
      const extractValues = (items) => {
        return (items || []).map(item => {
          if (typeof item === 'string') {
            return item;
          } else if (item && typeof item === 'object') {
            const value = item.value || item.text || item.label;
            return typeof value === 'string' ? value : String(value || item);
          }
          return String(item);
        }).filter(Boolean);
      };

      filtersLoadedRef.current = true;
      setFilters(prev => ({
        ...prev,
        selectedLocations: extractValues(initialFilters.locations),
        selectedIndustries: extractValues(initialFilters.industries),
        selectedJobTitles: extractValues(initialFilters.title),
        selectedExperienceLevels: selectedExperienceLevels,
        selectedSkills: extractValues(initialFilters.skills),
        selectedCompanies: extractValues(initialFilters.companies),
        selectedKeywords: selectedKeywords,
        selectedLanguages: selectedLanguages
      }));
      return;
    }
    
    // Find the selected user's filters
    const userFilters = allProjectFilters.find(filter => filter.created_by === userId);
    if (userFilters) {
      // Transform the user's filters to the expected format
      const transformedFilters = transformUserFiltersToAdvancedFilters(userFilters);
      
      // Update filters state with the selected user's filters
      filtersLoadedRef.current = true;
      setFilters(prev => ({
        ...prev,
        selectedLocations: transformedFilters.locations || [],
        selectedIndustries: transformedFilters.industries || [],
        selectedJobTitles: transformedFilters.title || [],
        selectedExperienceLevels: transformedFilters.yearsOfExperience || [],
        selectedSkills: transformedFilters.skills || [],
        selectedCompanies: transformedFilters.companies || [],
        selectedKeywords: transformedFilters.keywords || [],
        selectedLanguages: transformedFilters.languages || []
      }));
    }
  };

  // Transform user filters from database format to component format
  const transformUserFiltersToAdvancedFilters = (userFilters) => {
    const transformedFilters = {};
    
    if (userFilters.locations) {
      const processed = safelySplitAndFilter(userFilters.locations);
      if (processed.length > 0) {
        transformedFilters.locations = processed;
      }
    }

    if (userFilters.title) {
      const processed = safelySplitAndFilter(userFilters.title);
      if (processed.length > 0) {
        transformedFilters.title = processed;
      }
    }

    if (userFilters.industries) {
      const processed = safelySplitAndFilter(userFilters.industries);
      if (processed.length > 0) {
        transformedFilters.industries = processed;
      }
    }

    if (userFilters.companies) {
      const processed = safelySplitAndFilter(userFilters.companies);
      if (processed.length > 0) {
        transformedFilters.companies = processed;
      }
    }

    // Fix: keywords should go to keywords, not companies
    if (userFilters.keywords) {
      const processed = safelyHandleSingleValue(userFilters.keywords);
      if (processed.trim().length > 0) {
        transformedFilters.keywords = [processed.trim()];
      }
    }

    if (userFilters.languages) {
      const processed = safelySplitAndFilter(userFilters.languages);
      if (processed.length > 0) {
        transformedFilters.languages = processed;
      }
    }

    if (userFilters.skills) {
      const processed = safelySplitAndFilter(userFilters.skills);
      if (processed.length > 0) {
        transformedFilters.skills = processed;
      }
    }

    if (userFilters.yearsOfExperience) {
      const processed = safelySplitAndFilter(
        userFilters.yearsOfExperience
      );
      if (processed.length > 0) {
        transformedFilters.yearsOfExperience = processed;
      }
    }

    return transformedFilters;
  };

  // Helper function to safely split comma-separated values
  const safelySplitAndFilter = (value) => {
    if (!value) return [];

    // Handle different data types
    if (typeof value === "string") {
      return value
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
    }

    // If it's already an array, return as is
    if (Array.isArray(value)) {
      return value.filter(
        (item) => item && typeof item === "string" && item.trim().length > 0
      );
    }

    // If it's neither string nor array, convert to string and try to split
    try {
      return String(value)
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
    } catch (error) {
      console.warn("Failed to process value:", value, error);
      return [];
    }
  };

  // Helper function to safely handle single values
  const safelyHandleSingleValue = (value) => {
    if (!value) return "";

    if (typeof value === "string") {
      return value.trim();
    }

    if (Array.isArray(value)) {
      return value.length > 0 ? String(value[0]).trim() : "";
    }

    try {
      return String(value).trim();
    } catch (error) {
      console.warn("Failed to process single value:", value, error);
      return "";
    }
  };

  // Helper function to get pill options with defaults
  const getPillOptions = (sectionKey, itemId) => {
    const pillKey = `${sectionKey}-${itemId}`;
    const defaultPreference = sectionKey === 'jobTitle'
      ? 'Current'
      : (sectionKey === 'company' && TOP_CONSULTING_COMPANIES.some(firm => firm.toLowerCase() === String(itemId).trim().toLowerCase()))
        ? 'Past not current'
        : 'Current or Past';

    return pillOptions[pillKey] || {
      priority: 'Can have',
      preference: defaultPreference
    };
  };

  // Helper function to update pill options
  const updatePillOptions = (sectionKey, itemId, optionType, value) => {
    const pillKey = `${sectionKey}-${itemId}`;
    setPillOptions(prev => ({
      ...prev,
      [pillKey]: {
        ...getPillOptions(sectionKey, itemId),
        [optionType]: value
      }
    }));
  };

  // Close menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeKeywordMenu || activePillMenu) {
        setActiveKeywordMenu(null);
        setActivePillMenu(null);
        setKeywordMenuPosition({});
        setPillMenuPosition({});
      }
      if (userDropdownOpen) {
        setUserDropdownOpen(false);
      }
    };

    if (activeKeywordMenu || activePillMenu || userDropdownOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [activeKeywordMenu, activePillMenu, userDropdownOpen]);

  const contentRef = React.useRef(null);
  const previousScrollPosition = React.useRef(0);
  const scrollTimeoutRef = React.useRef(null);
  const savedFiltersRef = React.useRef(null);
  const saveTimeoutRef = React.useRef(null);
  const mountedRef = React.useRef(true);
  const lastPostedRef = React.useRef(null); // last snapshot the backend accepted in this session

  // The parent only hears about saves on close: updating initialFilters while open would reload the form mid-edit
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      if (lastPostedRef.current) onFiltersSaved?.(JSON.parse(lastPostedRef.current));
    };
  }, []);

  // Save every edit (removed pill, new value on Enter, priority change...) without sending anything to LinkedIn.
  // Must stay above the initialFilters effect: on mount this one runs first and takes the empty defaults as the
  // baseline, then the load's own render is skipped via filtersLoadedRef.
  useEffect(() => {
    const snapshot = JSON.stringify(buildActiveFilters());
    if (savedFiltersRef.current === null || filtersLoadedRef.current) {
      filtersLoadedRef.current = false;
      savedFiltersRef.current = snapshot;
      return;
    }
    if (snapshot === savedFiltersRef.current) return;

    clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(async () => {
      try {
        const token = JSON.parse(localStorage.getItem("eph-token")).value;
        // const url = `http://localhost:5005/helper/save-filters`;
        const url = `${URI}helper/save-filters`;
        const response = await fetch(url, {
        // const response = await fetch(`${URI}helper/save-filters`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "x-access-token": token },
          body: JSON.stringify({ token: decodeJwt(token)?.preferred_username, filters: JSON.parse(snapshot), projectID: projectId }),
        });
        if (response.ok) {
          savedFiltersRef.current = snapshot;
          lastPostedRef.current = snapshot;
          // Closed before this save finished: the unmount below already ran, so tell the parent now
          if (!mountedRef.current) onFiltersSaved?.(JSON.parse(snapshot));
        } else {
          console.error("Failed to save filters: HTTP", response.status);
        }
      } catch (err) {
        console.error("Failed to save filters:", err);
      }
    }, 500);
  }, [filters, pillOptions]);

  // Initialize filters with initialFilters prop
  useEffect(() => {
    if (Object.keys(initialFilters).length > 0) {
      // Map experience level labels back to IDs
      const selectedExperienceLevels = (initialFilters.yearsOfExperience || []).map(item => {
        const labelValue = typeof item === 'string' ? item : (item.value || item.label || String(item));
        const level = filters.experienceLevels.find(level => level.label === labelValue);
        return level?.id || labelValue;
      }).filter(Boolean);

      // Map language labels back to IDs
      const selectedLanguages = (initialFilters.languages || []).map(item => {
        const labelValue = typeof item === 'string' ? item : (item.value || item.label || String(item));
        const language = filters.languages.find(lang => lang.label === labelValue);
        return language?.id || labelValue;
      }).filter(Boolean);

      // Transform keywords from {value, priority, preference} to {id, text, priority, preference}
      const selectedKeywords = (initialFilters.keywords || []).map(keyword => {
        if (typeof keyword === 'string') {
          return {
            id: Date.now().toString() + Math.random(),
            text: keyword,
            priority: 'Can have',
            preference: 'Current or Past'
          };
        } else if (keyword && typeof keyword === 'object') {
          const text = keyword.value || keyword.text || keyword.label || String(keyword);
          return {
            id: keyword.id || (Date.now().toString() + Math.random()),
            text: typeof text === 'string' ? text : String(text),
            priority: keyword.priority || 'Can have',
            preference: keyword.preference || 'Current or Past'
          };
        }
        return {
          id: Date.now().toString() + Math.random(),
          text: String(keyword),
          priority: 'Can have',
          preference: 'Current or Past'
        };
      }).filter(item => item.text && item.text.trim());

      // Helper function to extract values from filter items
      const extractValues = (items) => {
        return (items || []).map(item => {
          if (typeof item === 'string') {
            return item;
          } else if (item && typeof item === 'object') {
            const value = item.value || item.text || item.label;
            // Ensure we return a string, not an object
            return typeof value === 'string' ? value : String(value || item);
          }
          return String(item);
        }).filter(Boolean); // Remove any empty values
      };

      filtersLoadedRef.current = true;
      setFilters(prev => ({
        ...prev,
        selectedLocations: extractValues(initialFilters.locations),
        selectedIndustries: extractValues(initialFilters.industries),
        selectedJobTitles: extractValues(initialFilters.title), // Note: using 'title' key from activeFilters
        selectedExperienceLevels: selectedExperienceLevels,
        selectedSkills: extractValues(initialFilters.skills),
        selectedCompanies: extractValues(initialFilters.companies),
        selectedKeywords: selectedKeywords,
        selectedLanguages: selectedLanguages
      }));

      // Restore pill options from initialFilters
      const restoredPillOptions = {};
      
      // Helper function to restore options for a section
      const restoreOptionsForSection = (sectionKey, items) => {
        (items || []).forEach(item => {
          if (item && typeof item === 'object' && (item.priority || item.preference)) {
            const itemId = item.value || item.text || item.label || item.id || item;
            const pillKey = `${sectionKey}-${itemId}`;
            restoredPillOptions[pillKey] = {
              priority: item.priority || 'Can have',
              preference: item.preference || 'Current or Past'
            };
          }
        });
      };

      // Restore options for all sections
      restoreOptionsForSection('location', initialFilters.locations);
      restoreOptionsForSection('industry', initialFilters.industries);
      restoreOptionsForSection('jobTitle', initialFilters.title);
      restoreOptionsForSection('skills', initialFilters.skills);
      restoreOptionsForSection('company', initialFilters.companies);
      
      // Special handling for job titles - set preference to "Current" if not already set
      (initialFilters.title || []).forEach(item => {
        const itemId = typeof item === 'string' ? item : (item.value || item.text || item.label || item.id || item);
        const pillKey = `jobTitle-${itemId}`;
        // If this job title doesn't have options set yet, set default with "Current" preference
        if (!restoredPillOptions[pillKey]) {
          restoredPillOptions[pillKey] = {
            priority: (item && typeof item === 'object' && item.priority) ? item.priority : 'Can have',
            preference: (item && typeof item === 'object' && item.preference) ? item.preference : 'Current'
          };
        } else {
          // If options exist but preference is default, set to "Current"
          if (!restoredPillOptions[pillKey].preference || restoredPillOptions[pillKey].preference === 'Current or Past') {
            restoredPillOptions[pillKey].preference = 'Current';
          }
        }
      });

      // Special handling for top consulting companies - set preference to "Past not current" if not already set or default
      (initialFilters.companies || []).forEach(item => {
        const itemId = typeof item === 'string' ? item : (item.value || item.text || item.label || item.id || item);
        const isTopFirm = TOP_CONSULTING_COMPANIES.some(
          firm => firm.toLowerCase() === String(itemId).trim().toLowerCase()
        );
        if (isTopFirm) {
          const pillKey = `company-${itemId}`;
          if (!restoredPillOptions[pillKey]) {
            restoredPillOptions[pillKey] = {
              priority: (item && typeof item === 'object' && item.priority) ? item.priority : 'Can have',
              preference: (item && typeof item === 'object' && item.preference && item.preference !== 'Current or Past') ? item.preference : 'Past not current'
            };
          } else if (!restoredPillOptions[pillKey].preference || restoredPillOptions[pillKey].preference === 'Current or Past') {
            restoredPillOptions[pillKey].preference = 'Past not current';
          }
        }
      });
      
      // Special handling for experience levels - need to map labels back to IDs for pill keys
      (initialFilters.yearsOfExperience || []).forEach(item => {
        if (item && typeof item === 'object' && (item.priority || item.preference)) {
          const labelValue = item.value || item.label || String(item);
          const level = filters.experienceLevels.find(level => level.label === labelValue);
          const experienceId = level?.id || labelValue;
          const pillKey = `experience-${experienceId}`;
          restoredPillOptions[pillKey] = {
            priority: item.priority || 'Can have',
            preference: item.preference || 'Current or Past'
          };
        }
      });
      
      // Special handling for languages - need to map labels back to IDs for pill keys
      (initialFilters.languages || []).forEach(item => {
        if (item && typeof item === 'object' && (item.priority || item.preference)) {
          const labelValue = item.value || item.label || String(item);
          const language = filters.languages.find(lang => lang.label === labelValue);
          const languageId = language?.id || labelValue;
          const pillKey = `languages-${languageId}`;
          restoredPillOptions[pillKey] = {
            priority: item.priority || 'Can have',
            preference: item.preference || 'Current or Past'
          };
        }
      });
      
      // Special handling for keywords since they have a different structure
      selectedKeywords.forEach(keyword => {
        if (keyword && typeof keyword === 'object') {
          const pillKey = `keywords-${keyword.id}`;
          restoredPillOptions[pillKey] = {
            priority: keyword.priority || 'Can have',
            preference: keyword.preference || 'Current or Past'
          };
        }
      });

      // Set the restored pill options
      setPillOptions(restoredPillOptions);

      console.log("initialFilters: ", initialFilters);
      console.log("restoredPillOptions: ", restoredPillOptions);
      
      // Auto-expand keywords section when there are values
      if (initialFilters.keywords && initialFilters.keywords.length > 0) {
        setExpandedSections(prev => ({
          ...prev,
          keywords: true
        }));
      }
    }
  }, [initialFilters]); // Update when initialFilters changes

  // Global scroll position preservation for all state changes
  React.useEffect(() => {
    if (contentRef.current) {
      const savedPosition = previousScrollPosition.current;

      // Clear any pending scroll restoration
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      // Multiple attempts to restore scroll position with different timing
      const restoreScrollPosition = () => {
        if (contentRef.current && savedPosition >= 0) {
          contentRef.current.scrollTop = savedPosition;
        }
      };

      // Immediate restoration
      restoreScrollPosition();

      // Delayed restorations to handle async rendering
      scrollTimeoutRef.current = setTimeout(restoreScrollPosition, 0);
      setTimeout(restoreScrollPosition, 10);
      setTimeout(restoreScrollPosition, 50);

      return () => {
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
      };
    }
  }, [
    filters.selectedLocations,
    filters.selectedIndustries,
    filters.selectedJobTitles,
    filters.selectedExperienceLevels,
    filters.selectedSkills,
    filters.selectedCompanies,
    filters.selectedKeywords,
    filters.selectedLanguages,
    expandedSections,
    filterSearchTerms
  ]);

  // Store scroll position on scroll events
  React.useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        previousScrollPosition.current = contentRef.current.scrollTop;
      }
    };

    const scrollElement = contentRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
        scrollElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  // TEMPORARILY DISABLED: Use a different approach: maintain scroll position using intersection observer
  // React.useEffect(() => {
  //   let scrollTimeoutId;

  //   const handleScroll = () => {
  //     // Completely disable scroll position saving to prevent any jumping
  //     if (contentRef.current && !isKeywordsInputFocused) {
  //       // Clear any pending scroll restoration
  //       if (scrollTimeoutId) {
  //         clearTimeout(scrollTimeoutId);
  //       }
  //       // Only store scroll position if no input is focused at all
  //       const activeElement = document.activeElement;
  //       const isAnyInputFocused = activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');

  //       if (!isAnyInputFocused) {
  //         previousScrollPosition.current = contentRef.current.scrollTop;
  //       }
  //     }
  //   };

  //   const scrollElement = contentRef.current;
  //   if (scrollElement) {
  //     scrollElement.addEventListener('scroll', handleScroll, { passive: true });
  //     return () => {
  //       scrollElement.removeEventListener('scroll', handleScroll);
  //       if (scrollTimeoutId) {
  //         clearTimeout(scrollTimeoutId);
  //       }
  //     };
  //   }
  // }, [isKeywordsInputFocused]);

  // TEMPORARILY DISABLED: Alternative approach: prevent scroll jumping by maintaining position with a more aggressive restoration
  // React.useEffect(() => {
  //   if (contentRef.current) {
  //     const savedPosition = previousScrollPosition.current;

  //     // Multiple attempts to restore scroll position
  //     const restore = () => {
  //       if (contentRef.current && savedPosition > 0 && !isKeywordsInputFocused) {
  //         // Additional check for any active input
  //         const activeElement = document.activeElement;
  //         const isAnyInputActive = activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');

  //         if (!isAnyInputActive) {
  //           contentRef.current.scrollTop = savedPosition;
  //         }
  //       }
  //     };

  //     // Immediate restoration
  //     restore();

  //     // Additional restorations with delays to handle async rendering
  //     const timeout1 = setTimeout(restore, 0);
  //     const timeout2 = setTimeout(restore, 10);
  //     const timeout3 = setTimeout(restore, 50);

  //     return () => {
  //       clearTimeout(timeout1);
  //       clearTimeout(timeout2);
  //       clearTimeout(timeout3);
  //     };
  //   }
  // }, [filterSearchTerms.location, filterSearchTerms.industry, filterSearchTerms.jobTitle, filterSearchTerms.skills, filterSearchTerms.company, isKeywordsInputFocused]);

  // TEMPORARILY DISABLED: Comprehensive scroll restoration for all filter selections
  // React.useEffect(() => {
  //   if (contentRef.current) {
  //     const savedPosition = previousScrollPosition.current;

  //     // Multiple attempts to restore scroll position for all sections
  //     const restore = () => {
  //       if (contentRef.current && savedPosition > 0 && !isKeywordsInputFocused) {
  //         // Additional check for any active input
  //         const activeElement = document.activeElement;
  //         const isAnyInputActive = activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');

  //         if (!isAnyInputActive) {
  //           contentRef.current.scrollTop = savedPosition;
  //         }
  //       }
  //     };

  //     // Immediate restoration
  //     restore();

  //     // Additional restorations with delays to handle async rendering
  //     const timeout1 = setTimeout(restore, 0);
  //     const timeout2 = setTimeout(restore, 10);
  //     const timeout3 = setTimeout(restore, 50);

  //     return () => {
  //       clearTimeout(timeout1);
  //       clearTimeout(timeout2);
  //       clearTimeout(timeout3);
  //     };
  //   }
  // }, [
  //   filters.selectedLocations,
  //   filters.selectedIndustries,
  //   filters.selectedJobTitles,
  //   filters.selectedSkills,
  //   filters.selectedCompanies,
  //   filters.selectedKeywords,
  //   filters.selectedExperienceLevels,
  //   filters.selectedLanguages,
  //   isKeywordsInputFocused
  // ]);

  // Toggle section expansion - memoized to prevent unnecessary re-renders
  const toggleSection = React.useCallback((section) => {
    // Store current scroll position before state update
    const currentScrollTop = contentRef.current?.scrollTop || 0;

    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));

    // Restore scroll position after state update
    requestAnimationFrame(() => {
      if (contentRef.current) {
        contentRef.current.scrollTop = currentScrollTop;
      }
    });
  }, []);

  // Handle filter selection - memoized to prevent unnecessary re-renders
  const handleFilterSelection = React.useCallback((category, itemId, isSelected) => {
    setFilters(prev => ({
      ...prev,
      [`selected${category.charAt(0).toUpperCase() + category.slice(1)}`]: isSelected
        ? [...prev[`selected${category.charAt(0).toUpperCase() + category.slice(1)}`], itemId]
        : prev[`selected${category.charAt(0).toUpperCase() + category.slice(1)}`].filter(id => id !== itemId)
    }));
  }, []);

  // Handle rate range change - memoized to prevent unnecessary re-renders
  const handleRateChange = React.useCallback((field, value) => {
    setFilters(prev => ({
      ...prev,
      rateRange: {
        ...prev.rateRange,
        [field]: value
      }
    }));
  }, []);

  // Handle single value filters - memoized to prevent unnecessary re-renders
  const handleSingleFilter = React.useCallback((field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  // Create stable callbacks for filter selection to prevent re-renders
  const handleLocationToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('locations', id, isSelected);
  }, [handleFilterSelection]);

  const handleIndustryToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('industries', id, isSelected);
  }, [handleFilterSelection]);

  const handleJobTitleToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('jobTitles', id, isSelected);
  }, [handleFilterSelection]);

  const handleExperienceToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('experienceLevels', id, isSelected);
  }, [handleFilterSelection]);

  const handleSkillsToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('skills', id, isSelected);
  }, [handleFilterSelection]);

  const handleCompanyToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('companies', id, isSelected);
  }, [handleFilterSelection]);

  const handleKeywordsToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('keywords', id, isSelected);
  }, [handleFilterSelection]);

  const handleLanguagesToggle = React.useCallback((id, isSelected) => {
    handleFilterSelection('languages', id, isSelected);
  }, [handleFilterSelection]);

  // Tag addition handlers for free text inputs
  const handleAddIndustryTag = React.useCallback((value) => {
    if (!filters.selectedIndustries.includes(value)) {
      setFilters(prev => ({
        ...prev,
        selectedIndustries: [...prev.selectedIndustries, value]
      }));
    }
  }, [filters.selectedIndustries]);

  const handleAddJobTitleTag = React.useCallback((value) => {
    if (!filters.selectedJobTitles.includes(value)) {
      setFilters(prev => ({
        ...prev,
        selectedJobTitles: [...prev.selectedJobTitles, value]
      }));
    }
  }, [filters.selectedJobTitles]);

  const handleAddSkillTag = React.useCallback((value) => {
    if (!filters.selectedSkills.includes(value)) {
      setFilters(prev => ({
        ...prev,
        selectedSkills: [...prev.selectedSkills, value]
      }));
    }
  }, [filters.selectedSkills]);

  const handleAddCompanyTag = React.useCallback((value) => {
    if (!filters.selectedCompanies.includes(value)) {
      setFilters(prev => ({
        ...prev,
        selectedCompanies: [...prev.selectedCompanies, value]
      }));

      const isTopConsulting = TOP_CONSULTING_COMPANIES.some(
        firm => firm.toLowerCase() === value.trim().toLowerCase()
      );
      if (isTopConsulting) {
        const pillKey = `company-${value}`;
        setPillOptions(prev => ({
          ...prev,
          [pillKey]: {
            priority: prev[pillKey]?.priority || 'Can have',
            preference: 'Past not current'
          }
        }));
      }
    }
  }, [filters.selectedCompanies]);

  const handleAddTopConsultingFirms = React.useCallback(() => {
    setFilters(prev => {
      const newCompanies = [...prev.selectedCompanies];
      TOP_CONSULTING_COMPANIES.forEach(firm => {
        if (!newCompanies.includes(firm)) {
          newCompanies.push(firm);
        }
      });
      return { ...prev, selectedCompanies: newCompanies };
    });

    setPillOptions(prev => {
      const updatedPillOptions = { ...prev };
      TOP_CONSULTING_COMPANIES.forEach(firm => {
        const pillKey = `company-${firm}`;
        updatedPillOptions[pillKey] = {
          priority: prev[pillKey]?.priority || 'Can have',
          preference: 'Past not current'
        };
      });
      return updatedPillOptions;
    });
  }, []);

  const handleSuggestAIKeywords = React.useCallback(async () => {
    setIsSuggestingKeywords(true);
    try {
      let keywordsFound = [];

      // 1. Try fetching AI summary keywords from the AI service endpoint
      try {
        const response = await fetch("https://ai.expertpowerhouse.com/expert-search/get-project-summary", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ projectID: Number(projectId) }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data.status === "success" && data.summary && Array.isArray(data.summary.keywords)) {
            keywordsFound = data.summary.keywords.filter(Boolean);
          }
        }
      } catch (err) {
        console.warn("Failed to get keywords from get-project-summary:", err);
      }

      // 2. If no keywords found from endpoint, derive up to 3 keywords from project details
      if (!keywordsFound.length && project) {
        if (project.skills && typeof project.skills === "string") {
          const rawSkills = project.skills.split(",").map(s => s.trim()).filter(Boolean);
          if (rawSkills.length > 0) {
            keywordsFound = rawSkills;
          }
        }
        if (!keywordsFound.length && (project.name || project.description)) {
          const text = ((project.name || "") + " " + (project.description || "")).replace(/<[^>]+>/g, " ");
          const stopWords = new Set([
            "the", "and", "for", "with", "that", "this", "from", "which", "have", "will", "are", "was",
            "were", "has", "had", "not", "but", "you", "your", "our", "can", "may", "should", "able",
            "in", "on", "at", "by", "of", "to", "a", "an", "is", "end", "including", "based", "support",
            "strong", "also", "initial", "assignment", "position", "candidate", "role", "roles", "please",
            "provide", "would", "could", "project", "requirements", "required", "we", "looking"
          ]);
          const words = text.match(/[A-Za-z0-9+#.-]{3,}/g) || [];
          const freq = {};
          words.forEach(w => {
            const clean = w.trim();
            if (!stopWords.has(clean.toLowerCase())) {
              freq[clean] = (freq[clean] || 0) + 1;
            }
          });
          keywordsFound = Object.keys(freq).sort((a, b) => freq[b] - freq[a]);
        }
      }

      // Limit to exactly 3 keywords
      const top3Keywords = keywordsFound.slice(0, 3);

      if (top3Keywords.length === 0) {
        Swal.fire({
          icon: "info",
          title: "No keywords found",
          text: "Could not extract keywords for this project. Please type keywords manually.",
          confirmButtonColor: "#0a66c2"
        });
        return;
      }

      setAiSuggestedKeywords(top3Keywords);

      // Add to selectedKeywords maintaining the frontend format
      const timestamp = Date.now();
      const generatedPills = {};

      setFilters(prev => {
        const existingTexts = new Set(
          prev.selectedKeywords.map(k => (typeof k === "string" ? k.toLowerCase() : (k.text || "").toLowerCase()))
        );

        const newKeywords = [...prev.selectedKeywords];
        top3Keywords.forEach((kw, idx) => {
          if (!existingTexts.has(kw.toLowerCase())) {
            const newId = "ai-" + timestamp + "-" + idx;
            newKeywords.push({
              id: newId,
              text: kw,
              priority: "Can have",
              preference: "Current or Past"
            });
            generatedPills["keywords-" + newId] = {
              priority: "Can have",
              preference: "Current or Past"
            };
          }
        });

        return {
          ...prev,
          selectedKeywords: newKeywords
        };
      });

      // Update pill options
      setPillOptions(prev => ({
        ...prev,
        ...generatedPills
      }));

      // Auto-expand keywords section so they are visible
      setExpandedSections(prev => ({
        ...prev,
        keywords: true
      }));

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "AI suggested 3 keywords: " + top3Keywords.join(", "),
        showConfirmButton: false,
        timer: 3500
      });
    } catch (error) {
      console.error("Error suggesting AI keywords:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not generate AI keyword suggestions.",
        confirmButtonColor: "#0a66c2"
      });
    } finally {
      setIsSuggestingKeywords(false);
    }
  }, [projectId, project]);

  const handleAddKeywordTag = React.useCallback((value) => {
    const existingKeyword = filters.selectedKeywords.find(k => 
      typeof k === 'string' ? k === value : k.text === value
    );
    
    if (!existingKeyword) {
      const newKeyword = {
        id: Date.now().toString(), // Simple unique ID
        text: value,
        priority: 'Can have', // Default priority changed to 'Can have'
        preference: 'Current or Past' // Default preference
      };
      
      setFilters(prev => ({
        ...prev,
        selectedKeywords: [...prev.selectedKeywords, newKeyword]
      }));
    }
  }, [filters.selectedKeywords]);




  // Simple search handlers
  const handleLocationSearch = (value) => {
    setFilterSearchTerms(prev => ({ ...prev, location: value }));
  };

  const handleIndustrySearch = (value) => {
    setFilterSearchTerms(prev => ({ ...prev, industry: value }));
  };

  const handleJobTitleSearch = (value) => {
    setFilterSearchTerms(prev => ({ ...prev, jobTitle: value }));
  };

  const handleSkillsSearch = (value) => {
    setFilterSearchTerms(prev => ({ ...prev, skills: value }));
  };

  const handleCompanySearch = (value) => {
    setFilterSearchTerms(prev => ({ ...prev, company: value }));
  };

  // Create persistent input refs to store across renders
  const inputRefs = React.useRef({
    location: null,
    industry: null,
    jobTitle: null,
    skills: null,
    company: null
  });

  // Tag Input Component for free text entry
  const TagInput = React.memo(({ placeholder, onAddTag, sectionKey }) => {
    const [inputValue, setInputValue] = React.useState('');

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && inputValue.trim()) {
        e.preventDefault();
        e.stopPropagation();

        // Store current scroll position before state update
        const currentScrollTop = contentRef.current?.scrollTop || 0;

        onAddTag(inputValue.trim());
        setInputValue('');

        // Restore scroll position after state update
        requestAnimationFrame(() => {
          if (contentRef.current) {
            contentRef.current.scrollTop = currentScrollTop;
          }
        });
      }
    };

    const handleInputChange = (e) => {
      setInputValue(e.target.value);
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    return (
      <form onSubmit={handleSubmit} style={{ marginBottom: '12px' }}>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            fontSize: '14px',
            outline: 'none',
            backgroundColor: '#ffffff',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#0a66c2';
            e.target.style.boxShadow = '0 0 0 2px rgba(10, 102, 194, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
        <div style={{
          fontSize: '12px',
          color: '#666',
          marginTop: '4px',
          fontStyle: 'italic'
        }}>
          Press Enter to add
        </div>
      </form>
    );
  });


  // Keywords Input Component with pill support and edit mode
  const KeywordTagInput = React.memo(({ placeholder, onAddTag }) => {
    const [inputValue, setInputValue] = React.useState('');
    const hasKeywords = filters.selectedKeywords.length > 0;

    // Set input value when editing a specific keyword
    React.useEffect(() => {
      if (isKeywordEditMode && editingKeyword) {
        const keywordText = typeof editingKeyword === 'string' ? editingKeyword : editingKeyword.text;
        setInputValue(keywordText);
      } else if (!isKeywordEditMode) {
        setInputValue('');
      }
    }, [isKeywordEditMode, editingKeyword]);

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && inputValue.trim()) {
        e.preventDefault();
        e.stopPropagation();

        // Store current scroll position before state update
        const currentScrollTop = contentRef.current?.scrollTop || 0;

        // If editing an existing keyword, replace it
        if (editingKeyword) {
          setFilters(prev => ({
            ...prev,
            selectedKeywords: prev.selectedKeywords.map(keyword => {
              if (typeof keyword === 'string') {
                if (keyword === editingKeyword) {
                  return {
                    id: Date.now().toString(),
                    text: inputValue.trim(),
                    priority: 'Must have',
                    preference: 'Current or Past'
                  };
                }
                return keyword;
              } else {
                if (keyword.id === editingKeyword.id || keyword.text === editingKeyword.text) {
                  return {
                    ...keyword,
                    text: inputValue.trim()
                  };
                }
                return keyword;
              }
            })
          }));
        } else {
          // Add new keyword
          onAddTag(inputValue.trim());
        }
        
        setInputValue('');
        setIsKeywordEditMode(false);
        setEditingKeyword(null);

        // Restore scroll position after state update
        requestAnimationFrame(() => {
          if (contentRef.current) {
            contentRef.current.scrollTop = currentScrollTop;
          }
        });
      }
    };

    const handleInputChange = (e) => {
      setInputValue(e.target.value);
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    const handleCancelEdit = () => {
      // Store current scroll position before state update
      const currentScrollTop = contentRef.current?.scrollTop || 0;

      setIsKeywordEditMode(false);
      setEditingKeyword(null);
      setInputValue('');

      // Restore scroll position after state update
      requestAnimationFrame(() => {
        if (contentRef.current) {
          contentRef.current.scrollTop = currentScrollTop;
        }
      });
    };

    // Render input form for adding or editing keywords
    return (
        <form onSubmit={handleSubmit} style={{ marginBottom: '12px' }}>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            autoFocus={isKeywordEditMode}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #e0e0e0',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none',
              backgroundColor: '#ffffff',
              transition: 'border-color 0.2s ease',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#0a66c2';
              e.target.style.boxShadow = '0 0 0 2px rgba(10, 102, 194, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e0e0e0';
              e.target.style.boxShadow = 'none';
            }}
          />
          <div style={{
            fontSize: '12px',
            color: '#666',
            marginTop: '4px',
            fontStyle: 'italic',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <span>
              {editingKeyword ? 'Press Enter to update keyword' : 'Press Enter to add keyword'}
            </span>
            {isKeywordEditMode && (
              <button
                type="button"
                onClick={handleCancelEdit}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#666',
                  fontSize: '12px',
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      );
  });

  // Simple search input with persistent DOM element
  const SearchInput = ({ placeholder, onChange, icon, inputKey }) => {
    const containerRef = React.useRef(null);
    const timeoutRef = React.useRef(null);

    React.useEffect(() => {
      // Create input element if it doesn't exist
      if (!inputRefs.current[inputKey]) {
        const input = document.createElement('input');
        input.type = 'text';
        input.placeholder = placeholder;
        input.style.cssText = `
          width: 100%;
          padding: 8px 12px 8px 36px;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          font-size: 14px;
          outline: none;
          background-color: #ffffff;
        `;

        input.addEventListener('input', (e) => {
          const value = e.target.value;

          // Clear existing timeout
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }

          // Set new timeout for debounced callback
          timeoutRef.current = setTimeout(() => {
            onChange(value);
          }, 800);
        });

        inputRefs.current[inputKey] = input;
      }

      // Append input to container if not already there
      if (containerRef.current && !containerRef.current.contains(inputRefs.current[inputKey])) {
        containerRef.current.appendChild(inputRefs.current[inputKey]);
      }

      return () => {
        // Don't remove the input on unmount to preserve value
      };
    }, [placeholder, onChange, inputKey]);

    return (
      <div style={{
        position: 'relative',
        marginBottom: '12px'
      }}>
        {icon && (
          <div style={{
            position: 'absolute',
            left: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666',
            fontSize: '14px',
            zIndex: 1
          }}>
            {icon}
          </div>
        )}
        <div ref={containerRef} />
      </div>
    );
  };

  function decodeJwt(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64).split('').map(c =>
          '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        ).join('')
      );
      return JSON.parse(jsonPayload);
    } catch (err) {
      console.error("❌ Failed to decode token:", err);
      return null;
    }
  }

  // The filters as sent to helpers, used by Apply and the autosave
  const buildActiveFilters = () => {
    // Helper function to add pill options to items
    const addPillOptionsToItems = (items, sectionKey) => {
      return items.map(item => {
        const itemId = typeof item === 'string' ? item : item.id || item;
        const options = getPillOptions(sectionKey, itemId);
        return {
          value: typeof item === 'string' ? item : (item.text || item.label || item),
          priority: options.priority,
          preference: options.preference
        };
      });
    };

    return {
      locations: addPillOptionsToItems(filters.selectedLocations, 'location'),
      industries: addPillOptionsToItems(filters.selectedIndustries, 'industry'),
      title: addPillOptionsToItems(filters.selectedJobTitles, 'jobTitle'),
      yearsOfExperience: addPillOptionsToItems(
        filters.selectedExperienceLevels.map(id => {
          const level = filters.experienceLevels.find(level => level.id === id);
          return { id, label: level?.label || id };
        }),
        'experience'
      ),
      skills: addPillOptionsToItems(filters.selectedSkills, 'skills'),
      companies: addPillOptionsToItems(filters.selectedCompanies, 'company'),
      keywords: addPillOptionsToItems(
        filters.selectedKeywords.map(keyword =>
          typeof keyword === 'string' ? keyword : keyword.text
        ),
        'keywords'
      ),
      languages: addPillOptionsToItems(
        filters.selectedLanguages.map(id => {
          const language = filters.languages.find(lang => lang.id === id);
          return { id, label: language?.label || id };
        }),
        'languages'
      )
    };
  };

  // Apply filters
  const handleApplyFilters = async () => {
    setLoading(true);
    try {
      const activeFilters = buildActiveFilters();

      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Call onApplyFilters to persist the filter state in parent component
      onApplyFilters(activeFilters);

      // const url = `https://tool.expertpowerhouse.com:3001/helper/filter-profile`;
      const url = `${URI}helper/filter-profile`;
      // const url = `http://localhost:5005/helper/filter-profile`;
      const ephToken = localStorage.getItem("eph-token");
      const token = JSON.parse(ephToken).value;

      const decodedToken = decodeJwt(token);

      const result = await ensureConnectionAndExecute(
        "filter_profile",
        async () => {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
            body: JSON.stringify({ "token": decodedToken?.preferred_username, filters: activeFilters, projectID: projectId }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          return await response.json();
        }
      );

      if (!result) {
        throw new Error("No response received from server");
      }

      if (result.status === "exception") {
        Swal.fire({
          icon: "info",
          title: "Error!",
          text: "Something went wrong!",
        });
        return;
      }

      if (result.status === "error") {
        if (result.message === "User not connected") {
          Swal.fire({
            icon: "error",
            title: "User not connected!",
            text: "Please reload the extension and update the project list!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.message || "Something went wrong!",
          });
        }
        return;
      }

      if (result.status === "queued") {
        const finalState = await pollTaskStatus(URI, result.task_id, token, {
          timeoutMs: 90000,
          intervalMs: 3000,
        });

        if (finalState.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Filters sent to LinkedIn!",
          });
        } else if (finalState.status === "timeout") {
          Swal.fire({
            icon: "warning",
            title: "Timeout",
            text: "The extension did not confirm completion in time. Please verify in the extension and try again.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Filter failed",
            text: finalState.error || "The extension reported an error while applying the filters.",
          });
        }
        return;
      }

      if (result.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Filters sent to LinkedIn!",
        });
        return;
      }

      Swal.fire({
        icon: "warning",
        title: "Unexpected response",
        text: "Received an unexpected status from the server.",
      });


    } catch (error) {
      console.error('Error applying filters:', error);
    } finally {
      setLoading(false);
      onClose()
    }
  };

  // Clear all filters
  const handleClearFilters = () => {
    setFilters(prev => ({
      ...prev,
      selectedLocations: [],
      selectedIndustries: [],
      selectedJobTitles: [],
      selectedExperienceLevels: [],
      selectedSkills: [],
      selectedCompanies: [],
      selectedKeywords: [],
      selectedLanguages: []
    }));

    // Reset keyword edit mode
    setIsKeywordEditMode(false);
    setEditingKeyword(null);
    setActiveKeywordMenu(null);
    setActivePillMenu(null);
    setKeywordMenuPosition({});
    setPillMenuPosition({});
    setPillOptions({});
  };

  // Memoized Location Options Component with scroll preservation
  const LocationOptions = React.memo(() => {
    // Store scroll position before rendering
    const currentScrollTop = contentRef.current?.scrollTop || 0;
    previousScrollPosition.current = currentScrollTop;

    const searchTerm = filterSearchTerms.location.toLowerCase();
    const filteredLocations = searchTerm
      ? filters.locations.filter(location => location.toLowerCase().includes(searchTerm))
      : filters.locations.slice(0, 5);

    return (
      <div className="filter-options">
        {filteredLocations.map((location, index) => (
          <FilterOption
            key={index}
            id={location}
            label={location}
            isSelected={filters.selectedLocations.includes(location)}
            onToggle={handleLocationToggle}
          />
        ))}
        {!filterSearchTerms.location && filters.locations.length > 5 && (
          <div style={{
            padding: '8px',
            fontSize: '12px',
            color: '#666',
            fontStyle: 'italic',
            textAlign: 'center'
          }}>
            Search to see more locations...
          </div>
        )}
      </div>
    );
  }, [filterSearchTerms.location, filters.selectedLocations]);

  // Memoized Industry Options Component with scroll preservation
  const IndustryOptions = React.memo(() => {
    // Store scroll position before rendering
    const currentScrollTop = contentRef.current?.scrollTop || 0;
    previousScrollPosition.current = currentScrollTop;

    const searchTerm = filterSearchTerms.industry.toLowerCase();
    const filteredIndustries = searchTerm
      ? filters.industries.filter(industry => industry.toLowerCase().includes(searchTerm))
      : filters.industries.slice(0, 5);

    return (
      <div className="filter-options">
        {filteredIndustries.map((industry, index) => (
          <FilterOption
            key={index}
            id={industry}
            label={industry}
            isSelected={filters.selectedIndustries.includes(industry)}
            onToggle={handleIndustryToggle}
          />
        ))}
        {!filterSearchTerms.industry && filters.industries.length > 5 && (
          <div style={{
            padding: '8px',
            fontSize: '12px',
            color: '#666',
            fontStyle: 'italic',
            textAlign: 'center'
          }}>
            Search to see more industries...
          </div>
        )}
      </div>
    );
  }, [filterSearchTerms.industry, filters.selectedIndustries]);

  // Memoized Job Title Options Component with scroll preservation
  const JobTitleOptions = React.memo(() => {
    // Store scroll position before rendering
    const currentScrollTop = contentRef.current?.scrollTop || 0;
    previousScrollPosition.current = currentScrollTop;

    const searchTerm = filterSearchTerms.jobTitle.toLowerCase();
    const filteredJobTitles = searchTerm
      ? filters.jobTitles.filter(jobTitle => jobTitle.toLowerCase().includes(searchTerm))
      : filters.jobTitles.slice(0, 5);

    return (
      <div className="filter-options">
        {filteredJobTitles.map((jobTitle, index) => (
          <FilterOption
            key={index}
            id={jobTitle}
            label={jobTitle}
            isSelected={filters.selectedJobTitles.includes(jobTitle)}
            onToggle={handleJobTitleToggle}
          />
        ))}
        {!filterSearchTerms.jobTitle && filters.jobTitles.length > 5 && (
          <div style={{
            padding: '8px',
            fontSize: '12px',
            color: '#666',
            fontStyle: 'italic',
            textAlign: 'center'
          }}>
            Search to see more job titles...
          </div>
        )}
      </div>
    );
  }, [filterSearchTerms.jobTitle, filters.selectedJobTitles]);

  // Memoized Skills Options Component with scroll preservation
  const SkillsOptions = React.memo(() => {
    // Store scroll position before rendering
    const currentScrollTop = contentRef.current?.scrollTop || 0;
    previousScrollPosition.current = currentScrollTop;

    const searchTerm = filterSearchTerms.skills.toLowerCase();
    const filteredSkills = searchTerm
      ? filters.skills.filter(skill => skill.toLowerCase().includes(searchTerm))
      : filters.skills.slice(0, 5);

    return (
      <div className="filter-options">
        {filteredSkills.map((skill, index) => (
          <FilterOption
            key={index}
            id={skill}
            label={skill}
            isSelected={filters.selectedSkills.includes(skill)}
            onToggle={handleSkillsToggle}
          />
        ))}
        {!filterSearchTerms.skills && filters.skills.length > 5 && (
          <div style={{
            padding: '8px',
            fontSize: '12px',
            color: '#666',
            fontStyle: 'italic',
            textAlign: 'center'
          }}>
            Search to see more skills...
          </div>
        )}
      </div>
    );
  }, [filterSearchTerms.skills, filters.selectedSkills]);

  // Memoized Company Options Component with scroll preservation
  const CompanyOptions = React.memo(() => {
    // Store scroll position before rendering
    const currentScrollTop = contentRef.current?.scrollTop || 0;
    previousScrollPosition.current = currentScrollTop;

    const searchTerm = filterSearchTerms.company.toLowerCase();
    const filteredCompanies = searchTerm
      ? filters.companies.filter(company => company.toLowerCase().includes(searchTerm))
      : filters.companies.slice(0, 5);

    return (
      <div className="filter-options">
        {filteredCompanies.map((company, index) => (
          <FilterOption
            key={index}
            id={company}
            label={company}
            isSelected={filters.selectedCompanies.includes(company)}
            onToggle={handleCompanyToggle}
          />
        ))}
        {!filterSearchTerms.company && filters.companies.length > 5 && (
          <div style={{
            padding: '8px',
            fontSize: '12px',
            color: '#666',
            fontStyle: 'italic',
            textAlign: 'center'
          }}>
            Search to see more companies...
          </div>
        )}
      </div>
    );
  }, [filterSearchTerms.company, filters.selectedCompanies]);

  // Memoized Experience Level Options Component with scroll preservation
  const ExperienceLevelOptions = React.memo(() => {
    // Store scroll position before rendering
    const currentScrollTop = contentRef.current?.scrollTop || 0;
    previousScrollPosition.current = currentScrollTop;

    return (
      <div className="filter-options">
        {filters.experienceLevels.map((level) => (
          <FilterOption
            key={level.id}
            id={level.id}
            label={level.label}
            count={level.count}
            isSelected={filters.selectedExperienceLevels.includes(level.id)}
            onToggle={handleExperienceToggle}
          />
        ))}
      </div>
    );
  }, [filters.selectedExperienceLevels]);

  // Memoized Language Options Component with scroll preservation
  const LanguageOptions = React.memo(() => {
    // Store scroll position before rendering
    const currentScrollTop = contentRef.current?.scrollTop || 0;
    previousScrollPosition.current = currentScrollTop;

    return (
      <div className="filter-options">
        {filters.languages.map((language) => (
          <FilterOption
            key={language.id}
            id={language.id}
            label={language.label}
            count={language.count}
            isSelected={filters.selectedLanguages.includes(language.id)}
            onToggle={handleLanguagesToggle}
          />
        ))}
      </div>
    );
  }, [filters.selectedLanguages]);

  // Helper function to get selected items for a section
  const getSelectedItems = (sectionKey) => {
    const addOptions = (item) => {
      const options = getPillOptions(sectionKey, item.id);
      return {
        ...item,
        priority: options.priority,
        preference: options.preference
      };
    };

    switch (sectionKey) {
      case 'location':
        return filters.selectedLocations.map(item => addOptions({ id: item, label: item }));
      case 'industry':
        return filters.selectedIndustries.map(item => addOptions({ id: item, label: item }));
      case 'jobTitle':
        return filters.selectedJobTitles.map(item => addOptions({ id: item, label: item }));
      case 'skills':
        return filters.selectedSkills.map(item => addOptions({ id: item, label: item }));
      case 'company':
        return filters.selectedCompanies.map(item => addOptions({ id: item, label: item }));
      case 'keywords':
        return filters.selectedKeywords.map(item => {
          const baseItem = {
            id: typeof item === 'string' ? item : item.id,
            label: typeof item === 'string' ? item : item.text,
            priority: typeof item === 'string' ? 'Must have' : item.priority,
            preference: typeof item === 'string' ? 'Current or Past' : item.preference
          };
          // For keywords, use stored options or item's own options
          const storedOptions = getPillOptions('keywords', baseItem.id);
          return {
            ...baseItem,
            priority: storedOptions.priority,
            preference: storedOptions.preference
          };
        });
      case 'experience':
        return filters.selectedExperienceLevels.map(id => {
          const level = filters.experienceLevels.find(level => level.id === id);
          return addOptions({ id, label: level?.label || id });
        });
      case 'languages':
        return filters.selectedLanguages.map(id => {
          const language = filters.languages.find(lang => lang.id === id);
          return addOptions({ id, label: language?.label || id });
        });
      default:
        return [];
    }
  };

  // Helper function to remove selected item
  const removeSelectedItem = (sectionKey, itemId) => {
    switch (sectionKey) {
      case 'location':
        handleLocationToggle(itemId, false);
        break;
      case 'industry':
        handleIndustryToggle(itemId, false);
        break;
      case 'jobTitle':
        handleJobTitleToggle(itemId, false);
        break;
      case 'skills':
        handleSkillsToggle(itemId, false);
        break;
      case 'company':
        handleCompanyToggle(itemId, false);
        break;
      case 'keywords':
        setFilters(prev => ({
          ...prev,
          selectedKeywords: prev.selectedKeywords.filter(keyword => 
            typeof keyword === 'string' ? keyword !== itemId : keyword.id !== itemId
          )
        }));
        break;
      case 'experience':
        handleExperienceToggle(itemId, false);
        break;
      case 'languages':
        handleLanguagesToggle(itemId, false);
        break;
    }
  };

  // Helper function to edit a keyword
  const editKeyword = (keywordId) => {
    const keyword = filters.selectedKeywords.find(k => 
      typeof k === 'string' ? k === keywordId : k.id === keywordId
    );
    setIsKeywordEditMode(true);
    setEditingKeyword(keyword);
  };

  // Helper function to update keyword priority/preference
  const updateKeywordOption = (keywordId, optionType, value) => {
    // Update the centralized pill options
    updatePillOptions('keywords', keywordId, optionType, value);
    setActiveKeywordMenu(null);
    setKeywordMenuPosition({});
  };

  // Helper function to calculate popup position near the three-dot button
  const calculatePopupPosition = (buttonElement) => {
    if (!buttonElement) return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
    
    const buttonRect = buttonElement.getBoundingClientRect();
    const popupWidth = 220; // min width of popup
    const popupHeight = 300; // estimated height of popup
    const margin = 8; // margin from button
    
    let top = buttonRect.bottom + margin;
    let left = buttonRect.left - (popupWidth / 2) + (buttonRect.width / 2);
    let transform = 'none';
    
    // Check if popup would go off the right edge
    if (left + popupWidth > window.innerWidth - 20) {
      left = window.innerWidth - popupWidth - 20;
    }
    
    // Check if popup would go off the left edge
    if (left < 20) {
      left = 20;
    }
    
    // Check if popup would go off the bottom edge
    if (top + popupHeight > window.innerHeight - 20) {
      // Position above the button instead
      top = buttonRect.top - popupHeight - margin;
      
      // If still doesn't fit, center it vertically
      if (top < 20) {
        top = Math.max(20, (window.innerHeight - popupHeight) / 2);
      }
    }
    
    // Check if popup would go off the top edge
    if (top < 20) {
      top = 20;
    }
    
    return {
      position: 'fixed',
      top: `${top}px`,
      left: `${left}px`,
      transform: transform
    };
  };

  // Helper function to update options for other sections
  const updatePillOption = (sectionKey, itemId, optionType, value) => {
    // Update the centralized pill options
    updatePillOptions(sectionKey, itemId, optionType, value);
    setActivePillMenu(null);
    setPillMenuPosition({});
  };

  // Selected Pills Component
  const SelectedPills = React.memo(({ sectionKey }) => {
    const selectedItems = getSelectedItems(sectionKey);
    const [hoveredPill, setHoveredPill] = React.useState(null);

    if (selectedItems.length === 0) return null;

    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        marginTop: '8px',
        marginBottom: '4px'
      }}>
        {selectedItems.map((item) => {
          const isHovered = hoveredPill === item.id || activeKeywordMenu === item.id || activePillMenu === `${sectionKey}-${item.id}`;
          
          return (
          <div
            key={item.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#e3f2fd',
              color: '#1565c0',
              fontSize: '12px',
              fontWeight: '500',
              padding: '6px 12px',
              borderRadius: '16px',
              border: '1px solid #bbdefb',
              position: 'relative',
              cursor: 'default',
              // Fixed width approach - prevent size changes
              width: 'fit-content',
              maxWidth: '250px', // Slightly larger to accommodate buttons
              minWidth: '80px', // Ensure minimum width
              overflow: 'hidden',
              flexShrink: 0
            }}
            onMouseEnter={() => setHoveredPill(item.id)}
            onMouseLeave={() => setHoveredPill(null)}
          >
            <span style={{
              display: 'inline-block',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              title: item.label,
              // Use width to control truncation - reduce width when buttons appear
              width: isHovered ? (sectionKey === 'keywords' ? 'calc(100% - 60px)' : 'calc(100% - 40px)') : '100%',
              transition: 'width 0.2s ease-out',
              maxWidth: '100%',
              minWidth: '0'
            }}>
              {/* Show priority prefix if not default */}
              {item.priority && item.priority !== 'Can have' && (
                <span style={{ fontWeight: 'bold' }}>{item.priority}: </span>
              )}
              {item.label}
              {/* Show preference suffix if not default */}
              {item.preference && item.preference !== 'Current or Past' && (
                <span style={{ fontSize: '11px', opacity: 0.8 }}> ({item.preference})</span>
              )}
            </span>
            
            {/* Always render buttons for keywords but control visibility */}
            {sectionKey === 'keywords' && (
              <>
                {/* Edit button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    editKeyword(item.id);
                  }}
                  style={{
                    position: 'absolute',
                    right: '46px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#1565c0',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    padding: '0',
                    margin: '0',
                    lineHeight: '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    transition: 'all 0.2s ease',
                    opacity: isHovered ? 0.9 : 0,
                    pointerEvents: isHovered ? 'auto' : 'none',
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = '1';
                    e.target.style.transform = 'translateY(-50%) scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = '0.9';
                    e.target.style.transform = 'translateY(-50%) scale(1)';
                  }}
                  title="Edit keyword"
                >
                  ✐
                </button>
                
                {/* Three-dot menu button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    
                    // Store current scroll position before state update
                    const currentScrollTop = contentRef.current?.scrollTop || 0;
                    
                    if (activeKeywordMenu === item.id) {
                      setActiveKeywordMenu(null);
                      setKeywordMenuPosition({});
                    } else {
                      // Calculate popup position relative to this button
                      const position = calculatePopupPosition(e.target);
                      setKeywordMenuPosition(position);
                      setActiveKeywordMenu(item.id);
                    }
                    
                    // Restore scroll position after state update
                    requestAnimationFrame(() => {
                      if (contentRef.current) {
                        contentRef.current.scrollTop = currentScrollTop;
                      }
                    });
                  }}
                  style={{
                    position: 'absolute',
                    right: '26px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#1565c0',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    padding: '0',
                    margin: '0',
                    lineHeight: '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    transition: 'all 0.2s ease',
                    opacity: isHovered ? 0.9 : 0,
                    pointerEvents: isHovered ? 'auto' : 'none',
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = '1';
                    e.target.style.transform = 'translateY(-50%) scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = '0.9';
                    e.target.style.transform = 'translateY(-50%) scale(1)';
                  }}
                  title="Keyword options"
                >
                  ⋯
                </button>
                
                {/* Delete button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeSelectedItem(sectionKey, item.id);
                  }}
                  style={{
                    position: 'absolute',
                    right: '6px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#1565c0',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '0',
                    margin: '0',
                    lineHeight: '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    transition: 'all 0.2s ease',
                    opacity: isHovered ? 0.9 : 0,
                    pointerEvents: isHovered ? 'auto' : 'none',
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = '1';
                    e.target.style.transform = 'translateY(-50%) scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = '0.9';
                    e.target.style.transform = 'translateY(-50%) scale(1)';
                  }}
                  title="Remove keyword"
                >
                  ×
                </button>

                {/* Options popup menu */}
                {activeKeywordMenu === item.id && (
                  <div
                    style={{
                      ...keywordMenuPosition,
                      backgroundColor: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      zIndex: 1001,
                      minWidth: '220px',
                      maxWidth: '300px',
                      padding: '8px 0'
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* Priority Group */}
                    <div style={{
                      padding: '8px 16px',
                      borderBottom: '1px solid #f0f0f0',
                      marginBottom: '4px'
                    }}>
                      <div style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#666',
                        marginBottom: '8px'
                      }}>
                        Priority
                      </div>
                      {['Must have', 'Can have', "Doesn't have"].map((priority) => (
                        <div
                          key={priority}
                          onClick={() => updateKeywordOption(item.id, 'priority', priority)}
                          style={{
                            padding: '6px 0',
                            fontSize: '14px',
                            cursor: 'pointer',
                            color: item.priority === priority ? '#1565c0' : '#333',
                            fontWeight: item.priority === priority ? 'bold' : 'normal',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f5f5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                        >
                          <span>{priority}</span>
                          {item.priority === priority && (
                            <span style={{ color: '#1565c0', fontSize: '12px' }}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Preferences Group */}
                    <div style={{
                      padding: '8px 16px'
                    }}>
                      <div style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#666',
                        marginBottom: '8px'
                      }}>
                        Preferences
                      </div>
                      {['Current or Past', 'Current', 'Past', 'Past not current'].map((preference) => (
                        <div
                          key={preference}
                          onClick={() => updateKeywordOption(item.id, 'preference', preference)}
                          style={{
                            padding: '6px 0',
                            fontSize: '14px',
                            cursor: 'pointer',
                            color: item.preference === preference ? '#1565c0' : '#333',
                            fontWeight: item.preference === preference ? 'bold' : 'normal',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f5f5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                        >
                          <span>{preference}</span>
                          {item.preference === preference && (
                            <span style={{ color: '#1565c0', fontSize: '12px' }}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
            
            {/* Always render buttons for other sections but control visibility */}
            {sectionKey !== 'keywords' && (
              <>
                {/* Three-dot menu button for other sections */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    
                    // Store current scroll position before state update
                    const currentScrollTop = contentRef.current?.scrollTop || 0;
                    
                    const menuId = `${sectionKey}-${item.id}`;
                    if (activePillMenu === menuId) {
                      setActivePillMenu(null);
                      setPillMenuPosition({});
                    } else {
                      // Calculate popup position relative to this button
                      const position = calculatePopupPosition(e.target);
                      setPillMenuPosition(position);
                      setActivePillMenu(menuId);
                    }
                    
                    // Restore scroll position after state update
                    requestAnimationFrame(() => {
                      if (contentRef.current) {
                        contentRef.current.scrollTop = currentScrollTop;
                      }
                    });
                  }}
                  style={{
                    position: 'absolute',
                    right: '26px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#1565c0',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    padding: '0',
                    margin: '0',
                    lineHeight: '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    transition: 'all 0.2s ease',
                    opacity: isHovered ? 0.9 : 0,
                    pointerEvents: isHovered ? 'auto' : 'none',
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = '1';
                    e.target.style.transform = 'translateY(-50%) scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = '0.9';
                    e.target.style.transform = 'translateY(-50%) scale(1)';
                  }}
                  title="Options"
                >
                  ⋯
                </button>
                
                {/* Delete button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeSelectedItem(sectionKey, item.id);
                  }}
                  style={{
                    position: 'absolute',
                    right: '6px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#1565c0',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '0',
                    margin: '0',
                    lineHeight: '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    transition: 'all 0.2s ease',
                    opacity: isHovered ? 0.9 : 0,
                    pointerEvents: isHovered ? 'auto' : 'none',
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = '1';
                    e.target.style.transform = 'translateY(-50%) scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = '0.9';
                    e.target.style.transform = 'translateY(-50%) scale(1)';
                  }}
                >
                  ×
                </button>

                {/* Options popup menu for other sections */}
                {activePillMenu === `${sectionKey}-${item.id}` && (
                  <div
                    style={{
                      ...pillMenuPosition,
                      backgroundColor: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      zIndex: 1001,
                      minWidth: '220px',
                      maxWidth: '300px',
                      padding: '8px 0'
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* Priority Group */}
                    <div style={{
                      padding: '8px 16px',
                      borderBottom: '1px solid #f0f0f0',
                      marginBottom: '4px'
                    }}>
                      <div style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#666',
                        marginBottom: '8px'
                      }}>
                        Priority
                      </div>
                      {['Must have', 'Can have', "Doesn't have"].map((priority) => (
                        <div
                          key={priority}
                          onClick={() => updatePillOption(sectionKey, item.id, 'priority', priority)}
                          style={{
                            padding: '6px 0',
                            fontSize: '14px',
                            cursor: 'pointer',
                            color: item.priority === priority ? '#1565c0' : '#333',
                            fontWeight: item.priority === priority ? 'bold' : 'normal',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f5f5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                        >
                          <span>{priority}</span>
                          {item.priority === priority && (
                            <span style={{ color: '#1565c0', fontSize: '12px' }}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Preferences Group */}
                    <div style={{
                      padding: '8px 16px'
                    }}>
                      <div style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#666',
                        marginBottom: '8px'
                      }}>
                        Preferences
                      </div>
                      {['Current or Past', 'Current', 'Past', 'Past not current'].map((preference) => (
                        <div
                          key={preference}
                          onClick={() => updatePillOption(sectionKey, item.id, 'preference', preference)}
                          style={{
                            padding: '6px 0',
                            fontSize: '14px',
                            cursor: 'pointer',
                            color: item.preference === preference ? '#1565c0' : '#333',
                            fontWeight: item.preference === preference ? 'bold' : 'normal',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f5f5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                        >
                          <span>{preference}</span>
                          {item.preference === preference && (
                            <span style={{ color: '#1565c0', fontSize: '12px' }}>✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          );
        })}
      </div>
    );
  }, [filters, activeKeywordMenu, activePillMenu, pillOptions]);

  // Completely redesigned simple filter section component
  const FilterSection = React.memo(({
    title,
    sectionKey,
    children,
    showSearch = false,
    searchPlaceholder = '',
    onSearchChange = () => { }
  }) => {
    const isExpanded = expandedSections[sectionKey];

    const handleToggle = React.useCallback(() => {
      toggleSection(sectionKey);
    }, [sectionKey]);



    return (
      <div style={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        marginBottom: '12px',
        backgroundColor: '#ffffff'
      }}>
        <div
          onClick={handleToggle}
          style={{
            padding: '12px 16px',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            borderBottom: isExpanded ? '1px solid #e0e0e0' : 'none',
            backgroundColor: '#f8f9fa'
          }}
        >
          <div style={{ flex: 1 }}>
            <span style={{ fontWeight: '600', fontSize: '14px', color: '#191919' }}>{title}</span>
            <SelectedPills sectionKey={sectionKey} />
          </div>
          <div style={{ marginLeft: '12px', marginTop: '2px' }}>
            {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        </div>

        {isExpanded && (
          <div style={{ padding: '12px 16px' }}>
            {showSearch && (
              <SearchInput
                placeholder={searchPlaceholder}
                onChange={onSearchChange}
                icon={<FaSearch />}
                inputKey={sectionKey}
              />
            )}
            {children}
          </div>
        )}
      </div>
    );
  });

  // Completely redesigned simple filter option component
  const FilterOption = React.memo(({
    id,
    label,
    count = 0,
    isSelected,
    onToggle,
    showCount = true
  }) => {
    const handleClick = React.useCallback((e) => {
      e.preventDefault();
      e.stopPropagation();

      // Store current scroll position before state update
      const currentScrollTop = contentRef.current?.scrollTop || 0;

      onToggle(id, !isSelected);

      // Restore scroll position after state update
      requestAnimationFrame(() => {
        if (contentRef.current) {
          contentRef.current.scrollTop = currentScrollTop;
        }
      });
    }, [onToggle, id, isSelected]);

    const handleCheckboxChange = React.useCallback((e) => {
      e.preventDefault();
      e.stopPropagation();

      // Store current scroll position before state update
      const currentScrollTop = contentRef.current?.scrollTop || 0;

      onToggle(id, !isSelected);

      // Restore scroll position after state update
      requestAnimationFrame(() => {
        if (contentRef.current) {
          contentRef.current.scrollTop = currentScrollTop;
        }
      });
    }, [onToggle, id, isSelected]);

    return (
      <label
        className="simple-filter-option"
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 12px',
          cursor: 'pointer',
          borderRadius: '4px',
          marginBottom: '2px',
          backgroundColor: isSelected ? '#e8f4fd' : 'transparent',
          color: isSelected ? '#0a66c2' : '#191919',
          transition: 'background-color 0.1s ease',
          userSelect: 'none'
        }}
      >
        <input
          type="checkbox"
          checked={isSelected}
          onChange={handleCheckboxChange}
          onClick={(e) => e.stopPropagation()}
          style={{
            marginRight: '12px',
            width: '16px',
            height: '16px',
            accentColor: '#0a66c2'
          }}
        />
        <span style={{ flex: 1, fontSize: '14px' }}>{label}</span>
        {showCount && count > 0 && (
          <span style={{ fontSize: '12px', color: '#666' }}>({count})</span>
        )}
      </label>
    );
  });

  // State for triggering keyword count updates
  const [keywordUpdateTrigger, setKeywordUpdateTrigger] = useState(0);

  // Get active filter count - calculated on each render (lightweight)
  const getActiveFilterCount = (() => {
    return (
      filters.selectedLocations.length +
      filters.selectedIndustries.length +
      filters.selectedJobTitles.length +
      filters.selectedExperienceLevels.length +
      filters.selectedSkills.length +
      filters.selectedCompanies.length +
      filters.selectedKeywords.length +
      filters.selectedLanguages.length
    );
  })();

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="advanced-filters-overlay"
        onClick={onClose}
      >
        <div
          className="advanced-filters-container"
          onClick={(e) => e.stopPropagation()}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          className="advanced-filters-popup"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="advanced-filters-header">
            <div className="advanced-filters-header-content">
              <FaFilter className="advanced-filters-icon" />
              <h2>LinkedIn Filters</h2>
              
              
              {/* User Filter Dropdown */}
              {getUniqueUsers().length > 0 && (
                <div style={{ 
                  position: 'relative', 
                  marginLeft: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <span style={{ 
                    fontSize: '12px', 
                    color: '#666',
                    whiteSpace: 'nowrap'
                  }}>
                    View filters by:
                  </span>
                  <div style={{ position: 'relative' }}>
                    <button
                      onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '6px 12px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        backgroundColor: '#ffffff',
                        color: '#333',
                        fontSize: '12px',
                        cursor: 'pointer',
                        minWidth: '120px',
                        justifyContent: 'space-between'
                      }}
                    >
                      <span>
                        {getSelectedUserDisplayName()}
                      </span>
                      <FaChevronDown 
                        style={{ 
                          fontSize: '10px',
                          transform: userDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.2s ease'
                        }} 
                      />
                    </button>
                    
                    {userDropdownOpen && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        backgroundColor: 'white',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        zIndex: 1002,
                        maxHeight: '200px',
                        overflowY: 'auto',
                        marginTop: '2px'
                      }}>
                        
                        {/* Other users */}
                        {getUniqueUsers().map((user) => (
                          <div
                            key={user.id}
                            onClick={() => handleUserSelectionChange(user.value)}
                            style={{
                              padding: '8px 12px',
                              fontSize: '12px',
                              cursor: 'pointer',
                              backgroundColor: selectedUser === user.value ? '#e8f4fd' : 'transparent',
                              color: selectedUser === user.value ? '#0a66c2' : '#333',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between'
                            }}
                            onMouseEnter={(e) => {
                              if (selectedUser !== user.value) {
                                e.target.style.backgroundColor = '#f5f5f5';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (selectedUser !== user.value) {
                                e.target.style.backgroundColor = 'transparent';
                              }
                            }}
                          >
                            <span>{user.label}</span>
                            {selectedUser === user.value && (
                              <FaCheck style={{ fontSize: '10px', color: '#0a66c2' }} />
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <button
              className="advanced-filters-close-btn"
              onClick={onClose}
            >
              <FaTimes />
            </button>
          </div>

          {/* Filters Content */}
          <div
            ref={contentRef}
            className="advanced-filters-content"
            style={{
              flex: 1,
              overflowY: 'auto',
              overscrollBehavior: 'contain', // Don't chain scroll to the page behind the popup
              padding: '0',
              backgroundColor: '#fafafa',
              scrollBehavior: 'auto',
              overflowAnchor: 'none',
              scrollPaddingTop: '0px' // Prevents auto-scroll to focused elements
            }}
          >
            {/* Location */}
            <FilterSection
              title="Location"
              sectionKey="location"
              showSearch={true}
              searchPlaceholder="Search locations..."
              onSearchChange={handleLocationSearch}
            >
              <LocationOptions />
            </FilterSection>

            {/* Industry */}
            <FilterSection
              title="Industry"
              sectionKey="industry"
            >
              <TagInput
                placeholder="Type industry and press Enter to add..."
                onAddTag={handleAddIndustryTag}
                sectionKey="industry"
              />
            </FilterSection>

            {/* Job Title */}
            <FilterSection
              title="Job Title"
              sectionKey="jobTitle"
            >
              <TagInput
                placeholder="Type job title and press Enter to add..."
                onAddTag={handleAddJobTitleTag}
                sectionKey="jobTitle"
              />
            </FilterSection>

            {/* Skills */}
            <FilterSection
              title="Skills"
              sectionKey="skills"
            >
              <TagInput
                placeholder="Type skill and press Enter to add..."
                onAddTag={handleAddSkillTag}
                sectionKey="skills"
              />
            </FilterSection>

            {/* Experience Level */}
            <FilterSection title="Experience Level" sectionKey="experience">
              <ExperienceLevelOptions />
            </FilterSection>

            {/* Company */}
            <FilterSection
              title="Company"
              sectionKey="company"
            >
              <div style={{ marginBottom: "10px" }}>
                <button
                  type="button"
                  onClick={handleAddTopConsultingFirms}
                  style={{
                    backgroundColor: "#f0f7ff",
                    color: "#0066cc",
                    border: "1px solid #b3d7ff",
                    borderRadius: "6px",
                    padding: "7px 14px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "all 0.2s ease"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e1f0ff"}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f0f7ff"}
                >
                  🏢 Add Top 25 Consulting Firms (MBB & Big 4)
                </button>
              </div>
              <TagInput
                placeholder="Type company and press Enter to add..."
                onAddTag={handleAddCompanyTag}
                sectionKey="company"
              />
            </FilterSection>

            {/* Keywords */}
            <FilterSection
              title="Keywords"
              sectionKey="keywords"
            >
              <div style={{ marginBottom: "12px", display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <button
                  type="button"
                  onClick={handleSuggestAIKeywords}
                  disabled={isSuggestingKeywords}
                  style={{
                    backgroundColor: "#f0f7ff",
                    border: "1px solid #cce5ff",
                    borderRadius: "6px",
                    color: "#0066cc",
                    cursor: isSuggestingKeywords ? "wait" : "pointer",
                    fontSize: "12px",
                    fontWeight: "500",
                    padding: "6px 12px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "all 0.2s ease",
                    opacity: isSuggestingKeywords ? 0.7 : 1
                  }}
                  onMouseOver={(e) => { if (!isSuggestingKeywords) e.currentTarget.style.backgroundColor = "#e1f0ff"; }}
                  onMouseOut={(e) => { if (!isSuggestingKeywords) e.currentTarget.style.backgroundColor = "#f0f7ff"; }}
                >
                  {isSuggestingKeywords ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '12px', height: '12px', display: 'inline-block' }}></span>
                      Analyzing project with AI...
                    </>
                  ) : (
                    <>
                      <span>✨</span> Suggest 3 Keywords with AI
                    </>
                  )}
                </button>
              </div>

              {aiSuggestedKeywords.length > 0 && (
                <div style={{
                  backgroundColor: "#f8fafd",
                  border: "1px solid #e2edfb",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  marginBottom: "12px",
                  fontSize: "12px"
                }}>
                  <div style={{ fontWeight: "600", color: "#0066cc", marginBottom: "6px" }}>
                    ✨ AI Suggestions for this project:
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                    {aiSuggestedKeywords.map((kw, i) => (
                      <span
                        key={i}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #cce5ff",
                          borderRadius: "12px",
                          padding: "2px 10px",
                          color: "#0066cc",
                          fontWeight: "500",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px"
                        }}
                      >
                        <FaCheck style={{ fontSize: "10px", color: "#28a745" }} /> {kw}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <KeywordTagInput
                placeholder="Type keywords and press Enter to add..."
                onAddTag={handleAddKeywordTag}
              />
            </FilterSection>

            {/* Languages */}
            <FilterSection title="Languages" sectionKey="languages">
              <LanguageOptions />
            </FilterSection>
          </div>

          {/* Footer */}
          <div style={{
            borderTop: '1px solid #e0e0e0',
            padding: '16px 20px',
            backgroundColor: '#ffffff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <button
                onClick={handleClearFilters}
                disabled={getActiveFilterCount === 0}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                  backgroundColor: '#ffffff',
                  color: '#666',
                  cursor: getActiveFilterCount === 0 ? 'not-allowed' : 'pointer',
                  opacity: getActiveFilterCount === 0 ? 0.5 : 1,
                  fontSize: '14px'
                }}
              >
                Clear all
              </button>
              {getActiveFilterCount > 0 && (
                <span className="active-filters-badge">
                  {getActiveFilterCount}
                </span>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={handleApplyFilters}
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: '#0a66c2',
                  color: '#ffffff',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  fontSize: '14px',
                  fontWeight: '600'
                }}
              >
                {loading ? 'Applying...' : 'Apply filters'}
              </button>
            </div>
          </div>
          </motion.div>

        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AdvancedFiltersPopup;
